import { render, staticRenderFns } from "./FormGiftExternalList.vue?vue&type=template&id=6a599d7a&"
import script from "./FormGiftExternalList.vue?vue&type=script&lang=js&"
export * from "./FormGiftExternalList.vue?vue&type=script&lang=js&"
import style0 from "./FormGiftExternalList.vue?vue&type=style&index=0&id=6a599d7a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports